import React from 'react';
import { CaptionText, HeadingText } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import MessageWithHTML from '../MessageWithHtml';

const GNSubheader = ({ organizationName, purpose }) => {
  return (
    <div className="donate_sub_header donate-main-content">
      <div className="gn-subheader">
        <CaptionText className="personal-fundraiser-header">
          <MessageWithHTML
            id="common.subHeader.label.donateToOrganization"
            organization={organizationName}
          />
        </CaptionText>
        <HeadingText className="gn-purpose" level={2}>
          {purpose}
        </HeadingText>
      </div>
    </div>
  );
};

GNSubheader.propTypes = {
  organizationName: PropTypes.string,
  purpose: PropTypes.string,
};

export default GNSubheader;
